<template>
  <!--<div id="bg">-->
    <div class="container">

      <div class="title">

        <!-- <router-link to="/help"><span>{{title}}</span><img src="/static/img/footer/footer-button.png"/></router-link> -->
        <a src='javascript:;'><span>{{title}}</span><img src="/static/img/footer/footer-button.png"/></a>
      </div>

      <div class="detail">

        <!-- <div class="link">
          <router-link to="/help">{{link1}}</router-link>
        </div>
        <div class="link">
          <router-link to="/help">{{link2}}</router-link>
        </div>
        <div class="link">
          <router-link to="/help">{{link3}}</router-link>
        </div>
        <div class="link">
          <router-link to="/help">{{link4}}</router-link>
        </div> -->
        <div class="link">
          <a src='javascript:;'>{{link1}}</a>
        </div>
        <div class="link">
          <a src='javascript:;'>{{link2}}</a>
        </div>
        <div class="link">
          <a src='javascript:;'>{{link3}}</a>
        </div>
        <div class="link">
          <a src='javascript:;'>{{link4}}</a>
        </div>
      </div>

    </div>

  <!--</div>-->
</template>

<script>
  export default {
    name: 'homeFooterText',
    props: ['title', 'link1', 'link2', 'link3', 'link4']
  }
</script>

<style scoped>

  div.container {
    border-left: solid;
    margin-right: 25px;
    padding-left: 25px;
    border-width: 1px;
    border-color: rgb(226, 226, 226);
    display: block;
    width: auto;
  }

  div.title {
    font-family: PingFangSC-Regular, "PingFang SC";
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
  }

  img {
    width: 25px;
    height: 25px;
    margin-left: 120px;
  }
  a {
    text-decoration: none;
  }
  div.detail {
    font-size: 14px;
    white-space: nowrap;
    font-family: 'ArialMT', 'Arial';
    font-weight: 400;
    font-style: normal;
  }
  div.link {
    margin-top: 20px;
  }
  .detail a {
    color: rgb(155,155,155);
  }
  .title a {
    color: rgb(73,73,73);
  }
</style>



// WEBPACK FOOTER //
// HomeFooterText.vue?dc62950e